<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  selectedCampaign: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);

const stopCampaign = async id => {
  if (!id) return;

  try {
    await store.dispatch('campaigns/cancel', id);
    useAlert(t('CAMPAIGN.CONFIRM_STOP.API.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(t('CAMPAIGN.CONFIRM_STOP.API.ERROR_MESSAGE'));
  }
};

const handleDialogConfirm = async () => {
  await stopCampaign(props.selectedCampaign.id);
  dialogRef.value?.close();
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('CAMPAIGN.CONFIRM_STOP.TITLE')"
    :description="t('CAMPAIGN.CONFIRM_STOP.DESCRIPTION')"
    :confirm-button-label="t('CAMPAIGN.CONFIRM_STOP.CONFIRM')"
    @confirm="handleDialogConfirm"
  />
</template>
